import React from 'react';
import { UserOutlined, ClockCircleOutlined } from '@ant-design/icons';
import {
  Avatar, Popover, Row,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { logout } from '../login/actions';
import { notifyConfirmation } from '../../utils/notification';
import UserDetailPopUp from './components/UserDetailPopUp';
import { SUBSCRIPTION_STATUS, ROUTES } from '../../constants';
import AccountSelector from '../../components/Selectors/AccountSelector';
import { ENABLE_BILLING_MODE } from '../../configs/app-config';

const MainHeader = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { fName, lName } = useAppSelector((state) => state.userData.userData);
  const { email, accounts } = useAppSelector((state) => state.userData);
  const { status: subStatus, trialEnd } = useAppSelector((state) => state.subscriptionData);
  const accountName = accounts?.map((account) => account.accountName);
  const isAccountActive: any = accounts?.map((account) => account.active);
  const showAccountSelector = (accounts?.length || 0) > 1;

  const isTrial = subStatus === SUBSCRIPTION_STATUS.TRIALING;

  const trialDaysLeft = React.useMemo(() => {
    if (!trialEnd) return null;
    const diff = Math.ceil(
      (new Date(trialEnd).getTime() - Date.now()) / (1000 * 60 * 60 * 24)
    );
    return diff > 0 ? diff : 0;
  }, [trialEnd]);

  const logOut = () => {
    notifyConfirmation('Are you sure you want to logout?', 'Yes', () => logout(dispatch), 'No', () => { });
  };

  const userDetailTitle = (
    <Row style={{ marginBottom: 15 }}>
      <p
        className="fp_heading-3 fp_mrgn_tp_15"
      >
        User Details
      </p>
    </Row>
  );

  return (
    <div className="fp_hdr_cntnr">
      <div className="fp_hdr_lft_cntnr">
        {showAccountSelector && <AccountSelector />}
      </div>
      <div className="fp_hdr_rght_cntnr">
        <div className="fp_hdr_innr_cntnr">
          {isTrial && ENABLE_BILLING_MODE && (
            <button
              className="trial-pill"
              onClick={() => navigate(ROUTES.BILLING)}
              title="You are on a free trial — click to manage your subscription"
            >
              <span className="trial-pill__pulse" />
              <ClockCircleOutlined className="trial-pill__icon" />
              <span className="trial-pill__label">
                {trialDaysLeft !== null
                  ? `Trial — ${trialDaysLeft}d left`
                  : 'Free Trial'}
              </span>
            </button>
          )}
          <div className="fp_cmpnt fp_cmpnt_flx_clmn fp_hdr_prfl_cntnr">
            <Popover
              zIndex={1000}
              destroyTooltipOnHide
              overlayClassName="fp_sd_pnl"
              placement="bottomRight"
              title={userDetailTitle}
              content={(
                <UserDetailPopUp
                  fName={fName}
                  lName={lName}
                  email={email}
                  accountName={accountName}
                  isAccountActive={isAccountActive}
                  logOut={logOut}
                />
              )}
              color="transparent"
              overlayStyle={{
                width: '30%',
                borderRadius: 10,
              }}
              showArrow={false}
            >
              <div
                className="fp_hdr_prfl fp_cmpnt fp_cmpnt_algn_itms_cntr fp_cmpnt_flx_rw"
                style={{ clear: 'both', whiteSpace: 'nowrap' }}
              >
                <Avatar
                  className="fp_mrgn_rght_10"
                  size="small"
                  icon={<UserOutlined />}
                />
                <div>
                  <p className="fp_hdr_prfl_name">{`${fName} ${lName}`}</p>
                </div>
              </div>
            </Popover>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainHeader;
